import {
  LOGIN_ENTRY,
  VIP_ACCOUNT,
  LOGIN_ENTRY_NORMAL,
  LOGIN_ENTRY_VIP
} from './constants'

const ACCOUNT_SALT = 'ECCS_VIP_LOGIN_V1'

function toBase64Url(str) {
  return btoa(str)
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '')
}

function fromBase64Url(str) {
  let b64 = str.replace(/-/g, '+').replace(/_/g, '/')
  while (b64.length % 4) {
    b64 += '='
  }
  return atob(b64)
}

function xorWithSalt(input) {
  let result = ''
  for (let i = 0; i < input.length; i++) {
    result += String.fromCharCode(
      input.charCodeAt(i) ^ ACCOUNT_SALT.charCodeAt(i % ACCOUNT_SALT.length)
    )
  }
  return result
}

/** 将明文账号编码为 URL 安全字符串（加盐异或 + Base64URL） */
export function encodeAccount(plain) {
  if (!plain) return ''
  const utf8 = unescape(encodeURIComponent(String(plain)))
  return toBase64Url(xorWithSalt(utf8))
}

/** 解码 URL 中的账号，失败返回 null */
export function decodeAccount(encoded) {
  if (!encoded) return null
  try {
    const utf8 = xorWithSalt(fromBase64Url(String(encoded)))
    const plain = decodeURIComponent(escape(utf8))
    return plain || null
  } catch (e) {
    return null
  }
}

export function getLoginEntry() {
  return localStorage.getItem(LOGIN_ENTRY) || LOGIN_ENTRY_NORMAL
}

export function isVipLoginEntry() {
  return localStorage.getItem(LOGIN_ENTRY) === LOGIN_ENTRY_VIP
}

export function getVipAccountEncoded() {
  return localStorage.getItem(VIP_ACCOUNT) || ''
}

export function setNormalLoginEntry() {
  localStorage.setItem(LOGIN_ENTRY, LOGIN_ENTRY_NORMAL)
  localStorage.removeItem(VIP_ACCOUNT)
}

export function setVipLoginEntry(encodedAccount) {
  localStorage.setItem(LOGIN_ENTRY, LOGIN_ENTRY_VIP)
  if (encodedAccount) {
    localStorage.setItem(VIP_ACCOUNT, encodedAccount)
  } else {
    localStorage.removeItem(VIP_ACCOUNT)
  }
}

/** clear 前取出入口信息，clear 后写回 VIP 标记 */
export function preserveLoginEntryAroundClear(clearFn) {
  const entry = localStorage.getItem(LOGIN_ENTRY)
  const account = localStorage.getItem(VIP_ACCOUNT)
  clearFn()
  if (entry === LOGIN_ENTRY_VIP) {
    localStorage.setItem(LOGIN_ENTRY, LOGIN_ENTRY_VIP)
    if (account) {
      localStorage.setItem(VIP_ACCOUNT, account)
    }
  }
}

export function buildLoginRouteLocation(extra = {}) {
  const entry = getLoginEntry()
  const account = getVipAccountEncoded()
  const num = Math.ceil(Math.random() * 10)
  // 注意：LOGIN_ENTRY_VIP 是本地标记值（如 profession），不是路由 name
  if (entry === LOGIN_ENTRY_VIP && account) {
    return {
      name: 'vipLogin',
      params: { account, ...(extra.params || {}) },
      ...(extra.query ? { query: extra.query } : {})
    }
  }
  if (entry === LOGIN_ENTRY_VIP) {
    return {
      name: 'vipLogin',
      params: { ...(extra.params || {}) },
      ...(extra.query ? { query: extra.query } : {})
    }
  }
  return {
    name: 'login',
    params: { num, force: true, ...(extra.params || {}) },
    ...(extra.query ? { query: extra.query } : {})
  }
}

/**
 * 登出 / token 失效 / 未登录时统一跳转登录页
 * @param {object} router vue-router 实例
 * @param {object} options
 * @param {'replace'|'push'} options.mode
 * @param {boolean} options.clearStorage 是否清理 localStorage（默认 true）
 */
export function redirectToLogin(router, options = {}) {
  const { mode = 'replace', clearStorage = true, query } = options
  const navigate = mode === 'push' ? 'push' : 'replace'

  if (clearStorage) {
    preserveLoginEntryAroundClear(() => {
      window.localStorage.clear()
    })
  }

  const location = buildLoginRouteLocation({ query })
  if (router && typeof router[navigate] === 'function') {
    router[navigate](location)
  }
}
